import React, { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "../shadcn/popover"
import { BsThreeDots } from "react-icons/bs"

export function DropdownMenu({
   options,
   content = null,
   ...props
}) {
   const [isOpen, setIsOpen] = useState(false)

   return (
      <Popover
         modal={true}
         open={isOpen}
         onOpenChange={setIsOpen}
      >
         <PopoverTrigger asChild>
            <button
               {...props}
               type="button"
               className="flex w-fit items-center justify-between rounded-(--borderRadius) border-none! px-3 py-2 hover:bg-(--borderColor)! duration-150"
            >
               <BsThreeDots size={18} />
               {props?.label}
            </button>
         </PopoverTrigger>

         <PopoverContent className="w-full p-2!">
            <div className="flex w-full flex-col gap-1.5!" {...props}>
               {content}
               {options.filter(o => o && Object.keys(o).length > 0).map((option) => (
                  <button
                     key={option.label}
                     type="button"
                     onClick={() => {
                        setIsOpen(false);
                        option?.onClick();
                     }}
                     disabled={option.disabled}
                     className="flex flex-row items-center justify-start gap-2! w-full rounded-(--borderRadius) px-3 py-2 text-left hover:bg-(--borderColor)! duration-150"
                  >
                     {option.icon && React.createElement(option.icon, { size: 18 })}
                     {option.label}
                  </button>
               ))}
            </div>
         </PopoverContent>
      </Popover>
   )
}
